import { LOCATION_CHANGE } from '../constants/locationConstants.js';

export const locationChange = ({ history }) => ({
    type: LOCATION_CHANGE,
    payload: {
        hash: history.location.hash,
        history,
    },
});
